<template>
    <div style="margin-top: 10px">
        <div class="row" v-if="currentValue == null">
            <div class="col-md-12">
                <base-input class="input-group-alternative mb-3" :placeholder="placeHolder" addon-left-icon="fa fa-fw fa-search" @keyup="buscar()" v-model="text"></base-input>
            </div>
            <div class="col-md-12" >
                <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
                    <div class="row" v-for="item in items" @click="itemClicked(item)" v-bind:key="item.id" :value="item.id" 
                        style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0">
                        <div class="col-10" style="display: flex">
                            <img :src="item.image" class="rounded-circle" style="width: 50px" alt=""/>
                            <div style="margin-left: 10px;margin-top: 10px;">
                                <div v-show="!showOnlyText">{{item.text}} {{item.description}}</div>
                                <div v-show="showOnlyText">{{item.text}}</div>
                            </div>
                        </div>
                        <div class="col-2 text-right" style="padding-top: 10px; padding-right: 25px">
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else style="background-color: white; padding: 5px; border-radius: 5px; margin-right: 0; margin-left: 0; border: #d6d4d4 1px solid">
            <div class="col-10" style="display: flex;">
                <img :src="currentValue.image" class="rounded-circle" style="width: 50px" alt=""/>
                <div style="margin-left: 10px;margin-top: 10px;">
                    <div v-show="!showOnlyText">{{currentValue.text}} {{currentValue.description}}</div>
                    <div v-show="showOnlyText">{{currentValue.text}}</div>
                </div>
            </div>
            <div class="col-2 text-right" style="padding-top: 10px; padding-right: 25px">
                <i class="fa fa-fw fa-times" style="cursor: pointer" @click="cleanSelected()"></i>
             </div>
        </div>
    </div>
</template>

<script>
    
    import notificationHelpers from '@/helpers/notificationHelpers';
    import axiosHelpers from '@/helpers/axiosHelpers';

    export default {
        props: {
            url: '',
            currentValue: null,
            minLength:{
                        type: Number,
                        default: 3,
            },
            placeHolder: {
                        type: String,
                        default: 'Buscar...',
            },
            showOnlyText:{
                type: Boolean,
                default: false
            }
        },    
        data() {
            return {
                timer: null,
                text: '',
                items: [],
                // selected: null,
            }
        },
        methods: {
            itemClicked(itemSelected){
                // this.selected = itemSelected;
                
                this.$emit('input', itemSelected);
            },
            buscar() {
                let context = this;
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    if(context.text.length >= context.minLength){
                        axiosHelpers.axiosGet(context.url, { Text: context.text}, context, function(data){ 
                            // context.movimientos = data.ResponseVM;
                            // console.log(data);
                            context.items = data.ResponseVM;
                        });
                    }else{
                        context.items = {};
                    }
                }, 800);
            },
            cleanSelected(){
                // this.selected = null;
                
                this.$emit('input', null);
            },
            limpiarControlBusqueda() {
                this.text = '';
                this.items = [];
            }
        }
    }
</script>